export default __webpack_public_path__ + "static/media/nurse-holding-senior-man-s-hands-sympathy.379258d2.jpg";